export default __webpack_public_path__ + "static/listing-page-own-802af771334bce02d0427bc0f872bbe1.png";